<template>
  <v-app-bar :clipped-left="false" app :elevation="0" outlined class="header-toolbar">
    <v-app-bar-nav-icon @click.stop="toggleLeftDrawer">
      <template v-slot:default="{ on }">
        <template v-on="on">
          <v-icon v-html="menuIcon" />
        </template>
      </template>
    </v-app-bar-nav-icon>
    <v-toolbar-title v-text="title" />
    <v-spacer />
    <specialMode></specialMode>
    <authBtn></authBtn>
    <v-btn icon @click.stop="toggleRightDrawer">
      <v-icon :color="notificationIcon.color">
        {{ notificationIcon.icon }}
      </v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Toolbar',

  components: {
    authBtn: () => import(
      '@/components/base/AuthBtn'
    ),
    specialMode: () => import(
      '@/components/base/SpecialMode'
    )
  },

  props: {
    title: {
      default: 'Menu',
      type: String
    },
    // left v-navigation-drawer
    leftDrawer: {
      default: false,
      type: Boolean
    },
    // mini-variant mode for v-navigation-drawer
    miniVariant: {
      default: true,
      type: Boolean
    },
    // right v-navigation-drawer
    rightDrawer: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    ...mapGetters({
      notifications: 'notification/notifications',
      countOfNotifications: 'notification/countOfNotifications'
    }),

    menuIcon: function() {
      if (this.leftDrawer) {
        return this.miniVariant ? 'chevron_right' : 'chevron_left'
      } else {
        return 'menu'
      }
    },

    unreadNotificationCount() {
      return this.notifications.filter(x => x.active === true).length
    },

    notificationIcon() {
      if (this.notifications.length === 0) {
        return {
          color: 'gray lighten-1',
          icon: 'notifications_none'
        }
      }
      return {
        color: this.unreadNotificationCount ? 'blue darken-1' : 'gray lighten-1',
        icon: this.unreadNotificationCount ? 'notifications_active' : 'notifications'
      }
    }
  },

  methods: {
    toggleRightDrawer: function() {
      this.$emit('update:right-drawer', !this.rightDrawer)
    },

    // states: closed -> mini variant -> full opened
    toggleLeftDrawer: function() {
      if (this.leftDrawer) {
        if (this.miniVariant) {
          this.$emit('update:mini-variant', false)
        } else {
          this.$emit('update:left-drawer', false)
        }
      } else {
        this.$emit('update:left-drawer', true)
        this.$emit('update:mini-variant', true)
      }
    }
  }
}
</script>
<style scoped>
.header-toolbar {
  border-bottom: solid #007bbc 1px !important;
}
</style>